import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/ats-recruiter/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandColorInitializer"] */ "/app/apps/ats-recruiter/src/component/common/BrandColorInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/ats-recruiter/src/layouts/CommonHookContainer.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/ats-recruiter/style/global.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
